const SEMESTER_LIST = [
    { title: '2023 Spring/Winter', value: '2023-spring/winter' },
    { title: '2023 Summer', value: '2023-summer' },
    { title: '2023 Fall', value: '2023-fall' },
    { title: '2024 Spring/Winter', value: '2024-spring/winter' },
];

export default SEMESTER_LIST;
